/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProfilingProfileComponent = {
  id?: number
  personality?: {
    id?: number
    influence?: number
    initiative?: number
    structure?: number
    relational?: number
  }
  rolesRanking?: Array<{
    id?: number
    role?:
      | 'administrateur'
      | 'adviseur'
      | 'bestuurder'
      | 'coach'
      | 'communicator'
      | 'controleur'
      | 'handhaver'
      | 'hulpverlener'
      | 'icter'
      | 'kunstenaar'
      | 'leider'
      | 'leraar'
      | 'natuurmens'
      | 'ondernemer'
      | 'ondersteuner'
      | 'onderzoeker'
      | 'projectleider'
      | 'technicus'
      | 'verkoper'
      | 'vernieuwer'
      | 'verzorger'
  }>
  motivationsRanking?: Array<{
    id?: number
    motivation?:
      | 'balansprivewerk'
      | 'financiele_beloning'
      | 'waardering_en_erkenning'
      | 'concrete_resultaten'
      | 'zinvolle_bijdrage'
      | 'carriere'
      | 'kwaliteit'
      | 'beinvloeden'
      | 'creatief_denken'
      | 'ondernemen'
      | 'hulp_verlenen'
      | 'analyseren'
      | 'ontwikkelen'
      | 'fysiek_actief_zijn'
      | 'autonomie'
      | 'zekerheid_en_stabiliteit'
      | 'taakuitdaging'
      | 'samenwerking'
      | 'aandacht'
      | 'hectiek'
  }>
  topCultureRanking?: Array<{
    id?: number
    cultureCharacteristic?:
      | 'competitief'
      | 'sociaal_collegiaal'
      | 'lerende_organisatie'
      | 'innovatief'
      | 'georganiseerd'
      | 'zorgvuldig_nadenkend'
      | 'winstgericht'
      | 'complimenteus'
      | 'resultaatgericht'
      | 'maatschappelijk'
      | 'kwaliteitsgericht'
      | 'creatief'
      | 'machtsgericht'
      | 'ondernemend'
      | 'vrijheid'
      | 'samenwerkend'
      | 'dynamisch'
      | 'ambitieus'
      | 'eerlijk'
      | 'compliant'
  }>
  minCultureRanking?: Array<{
    id?: number
    cultureCharacteristic?:
      | 'competitief'
      | 'sociaal_collegiaal'
      | 'lerende_organisatie'
      | 'innovatief'
      | 'georganiseerd'
      | 'zorgvuldig_nadenkend'
      | 'winstgericht'
      | 'complimenteus'
      | 'resultaatgericht'
      | 'maatschappelijk'
      | 'kwaliteitsgericht'
      | 'creatief'
      | 'machtsgericht'
      | 'ondernemend'
      | 'vrijheid'
      | 'samenwerkend'
      | 'dynamisch'
      | 'ambitieus'
      | 'eerlijk'
      | 'compliant'
  }>
  education?: {
    id?: number
    min?: ProfilingProfileComponent.min
    max?: ProfilingProfileComponent.max
  }
}
export namespace ProfilingProfileComponent {
  export enum min {
    VMBO = 'VMBO',
    MBO = 'MBO',
    HBO = 'HBO',
    WO = 'WO',
    WO_PLUS = 'WO_PLUS',
  }
  export enum max {
    VMBO = 'VMBO',
    MBO = 'MBO',
    HBO = 'HBO',
    WO = 'WO',
    WO_PLUS = 'WO_PLUS',
  }
}
